/**
 * ProductAdminRequired — contained UI state for an authenticated caller whose
 * token lacks the `productAdminOf` grant. Keep this gate in-component so the
 * user sees a terminal denial instead of entering a sign-in loop.
 *
 * Usage:
 *   const productAdmin = useCurrentProductAdmin();
 *   if (!productAdmin) return <ProductAdminRequired />;
 */
import { Box, Typography } from '@mui/material';
import { useCopy } from '@/hooks/useCopy';

export function ProductAdminRequired() {
  const { t } = useCopy();
  return (
    <Box
      role="alert"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '40vh',
        gap: 1,
        textAlign: 'center',
        px: 2,
      }}
    >
      <Typography variant="h2" component="p">
        {t('auth.productAdminRequired', 'Product admin access required')}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 400 }}>
        {t(
          'auth.productAdminRequiredBody',
          "You're signed in, but your account hasn't been granted access to this product admin console.",
        )}
      </Typography>
    </Box>
  );
}
